// extracted by mini-css-extract-plugin
export default {"content":"analytics_content__5L1M+","titleReview":"analytics_titleReview__8++Kf"};